import React from "react";
import { Clock, Tag, CheckCircle2 } from "lucide-react";
import { PHONES, toTel } from "../../mock";

const IconItem = ({ icon: Icon, children }) => (
  <div className="flex items-center gap-2.5 text-white">
    <Icon className="h-5 w-5 shrink-0" strokeWidth={2} />
    <span className="text-[15px]">{children}</span>
  </div>
);

const FinalCTA = () => {
  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: "var(--me-navy)" }}>
      <div className="max-w-[880px] mx-auto px-6 text-center">
        <h2 className="text-[30px] md:text-[42px] font-extrabold leading-tight text-white">
          Réduisez vos factures d'électricité dès aujourd'hui
        </h2>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-10">
          <IconItem icon={Clock}>Appel gratuit 8h-21h</IconItem>
          <IconItem icon={Tag}>Nouveaux tarifs</IconItem>
          <IconItem icon={CheckCircle2}>Ouverture de compteur</IconItem>
        </div>

        <div className="mt-10 flex justify-center">
          <a
            href={toTel(PHONES.finalCta)}
            className="flex w-full max-w-[560px] flex-col items-center rounded-full px-12 py-4 text-white shadow-[0_14px_30px_rgba(38,38,221,0.35)] transition-colors"
            style={{ backgroundColor: "var(--me-blue)" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue)")}
          >
            <span className="text-[21px] font-bold tracking-wide">Parler à un conseiller</span>
            <span className="text-[12px] opacity-90">Appel Gratuit</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
